import { DropdownMenuItem } from '@aon/aon-tws-common-ui';
import { ActionMenuWrapper } from '@aon/aon-tws-common-ui/build/lib/components/Table';
import _ from 'lodash';
import * as React from 'react';
import { default as ContentConstants, default as contentConstants } from '../../../contentConstants';
import { IEmailTemplate } from '../../../models';
import { ToastType } from '../../audience/ToastType';
import { SendEmailModal } from '../../audience/email/SendEmailModal';
import { WarningModal } from '../../common/WarningModal';

export interface IReminderActionMenuProps {
	reminderEmail: IEmailTemplate;
	surveyId: number;
	audienceId: number;
	DeleteEmailTemplate: (emailTemplateId: number) => void;
	Toast: (type: ToastType, message: string) => void;
	ToggleReminderModal: (open: boolean) => void;
}

export interface IReminderActionMenuState {
	deleteModalToggle: boolean;
	isSendEmailModalOpen: boolean;
}

export class ReminderActionMenu extends React.Component<IReminderActionMenuProps, IReminderActionMenuState> {
	constructor(props: IReminderActionMenuProps) {
		super(props);

		this.state = { deleteModalToggle: false, isSendEmailModalOpen: false };
		this.toggleDeleteModal = this.toggleDeleteModal.bind(this);
		this.handleDelete = this.handleDelete.bind(this);
		this.toggleSendEmailModal = this.toggleSendEmailModal.bind(this);
	}

	public render() {
		const warningModalContentBody = _.replace(
			ContentConstants.WARNING_MODAL_DELETE_BODY,
			new RegExp('{name}', 'g'),
			this.props.reminderEmail.emailTemplateName || '',
		);
		return (
			<>
				<ActionMenuWrapper>
					<DropdownMenuItem onClick={() => this.props.ToggleReminderModal(true)}>{contentConstants.ACTIONMENU_EDIT}</DropdownMenuItem>
					<DropdownMenuItem onClick={() => this.toggleDeleteModal(true)}>{contentConstants.ACTIONMENU_DELETE}</DropdownMenuItem>
					<DropdownMenuItem onClick={() => this.toggleSendEmailModal(true)}>{contentConstants.BUTTONS_SEND_TEST_EMAIL}</DropdownMenuItem>
				</ActionMenuWrapper>
				<WarningModal
					isOpen={this.state.deleteModalToggle}
					contentHeadline={ContentConstants.WARNING_MODAL_DELETE_HEADLINE}
					contentBody={warningModalContentBody}
					secondaryButtonText={ContentConstants.BUTTONS_CANCEL}
					onClose={() => this.toggleDeleteModal(false)}
					onSubmit={this.handleDelete}
				/>
				<SendEmailModal
					modalOpen={this.state.isSendEmailModalOpen}
					emailTemplate={this.props.reminderEmail}
					shouldReplaceSurveyLink={true}
					surveyId={this.props.surveyId}
					closeModal={() => this.toggleSendEmailModal(false)}
				/>
			</>
		);
	}

	public handleDelete() {
		this.props.DeleteEmailTemplate(this.props.reminderEmail.emailTemplateId);
		this.toggleDeleteModal(false);
	}

	private toggleDeleteModal(open: boolean) {
		this.setState({ deleteModalToggle: open });
	}

	private toggleSendEmailModal(isOpen: boolean) {
		this.setState({ isSendEmailModalOpen: isOpen });
	}
}
